
export const validationService = {
    isValidPassword,
    isValidEmail
}

function isValidPassword(val){
    const regex = /^(?=^.{6,18}$)(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&amp;*()_+}{&quot;:;'?/&gt;.&lt;,])(?!.*\s).*$/;
    return val && regex.test(String(val)) ? true : false;
}

function isValidEmail(val){
    var regex = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    return val && regex.test(String(val).toLowerCase()) ? true : false;
}